module.exports = __webpack_public_path__ + "img/group1.adc2fa70.svg";